import React, { useContext, useEffect } from 'react';

import { InfusionScreen } from '../../../../types';

import CalculatorComponent from '../../../../components/CalculatorComponent';

import { InfusionAddedDrugContext } from '../../../../contexts/InfusionProvider/InfusionAddedDrugProvider';
import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { CalculatorContext } from '../../../../contexts/CalculatorProvider';
import { isValidInputValueTimer } from '../../../../utils';

function InfusionAddedDrugPageSixthScreen(): React.ReactElement {
 const {
  setBackButtonText,
  setNextButtonText,
  setNextButtonDisabled,
  setNextButtonAction,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { setCurrentScreen, onValueTimerChange, getValueTimerInitialState } =
  useContext(InfusionAddedDrugContext);

 const { setHasCheckbox, setQuestion, setShowInfo, setIsTimer } =
  useContext(CalculatorContext);

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(() => () => {
    setCurrentScreen(InfusionScreen.AddedDrug.Fifth);
    setIsTimer(false);
   });
  };
  const setNextButtonProps = () => {
   setNextButtonText('Regn ut');
   setNextButtonAction(() => () => {
    setCurrentScreen(InfusionScreen.AddedDrug.Result);
    setIsTimer(false);
   });
  };
  setBackButtonProps();
  setNextButtonProps();
 };

 const setCalculatorProps = () => {
  setHasCheckbox(false);
  setQuestion('Hvor lenge skal infusjonen vare?');
  setShowInfo(false);
  setIsTimer(true);
 };

 useEffect(() => {
  if (isValidInputValueTimer(getValueTimerInitialState())) {
   setNextButtonDisabled(false);
  }
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return (
  <CalculatorComponent
   onValueTimerChange={onValueTimerChange}
   valueTimerInitialState={getValueTimerInitialState()}
  />
 );
}

export default InfusionAddedDrugPageSixthScreen;
